import * as React from 'react';
import React__default from 'react';

function createCommonjsModule(fn) {
  var module = { exports: {} };
	return fn(module, module.exports), module.exports;
}

var _extends_1 = createCommonjsModule(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;
});

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var objectWithoutPropertiesLoose = _objectWithoutPropertiesLoose;

var _excluded = ["color", "size", "style"];
var Icon = (function (SvgComponent) {
  return /*#__PURE__*/React__default.forwardRef(function (props, ref) {
    var _props$color = props.color,
        color = _props$color === void 0 ? 'currentColor' : _props$color,
        _props$size = props.size,
        size = _props$size === void 0 ? '1em' : _props$size,
        _props$style = props.style,
        style = _props$style === void 0 ? {} : _props$style,
        otherProps = objectWithoutPropertiesLoose(props, _excluded);

    return /*#__PURE__*/React__default.createElement(SvgComponent, _extends_1({
      ref: ref,
      fill: color,
      width: size,
      height: size,
      style: _extends_1({}, style)
    }, otherProps));
  });
});

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M59.538 59.538h359.57V0H0v419.109h59.538V59.539zm904.924 904.924h-359.57V1024H1024V604.891h-59.538v359.57zm-533.577-379.1l-232.229.585c-12.946.366-20.7 10.972-21.065 23.918v16.53c-.366 12.947 10.971 23.187 23.918 22.967l155.794-.95L82.578 924.598a32.183 32.183 0 1045.349 45.348L401.993 694.93l.366 151.699c-.366 12.946 8.777 24.868 23.99 27.062h16.531a25.015 25.015 0 0024.137-23.99l-.95-230.181.146-.512.219-11.776a21.797 21.797 0 00-6.656-16.53c-4.17-4.243-10.094-5.705-16.53-5.56l-12.361.22zm117.248-118.199l232.228-.512c12.873-.438 20.7-11.044 21.065-23.99v-16.53c.366-12.947-10.971-23.187-23.917-22.968l-155.795.951L896.44 128a32.183 32.183 0 10-45.349-45.422L577.024 357.595l-.439-151.698a26.55 26.55 0 00-23.918-27.063h-16.53A25.015 25.015 0 00512 202.825l.95 230.18-.219.513-.146 11.849a21.797 21.797 0 006.583 16.53c4.242 4.17 10.094 5.632 16.603 5.486l12.362-.22z"
});

function SvgFullscreenCancel(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fullscreenCancel_svg__icon",
    width: 200,
    height: 200,
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullscreenCancel);

var ForwardIcon = /*#__PURE__*/React__default.forwardRef(function (props, ref) {
  return /*#__PURE__*/React__default.createElement(ForwardRef, _extends_1({}, props, {
    ref: ref
  }));
});
var KuFoxIcons = Icon(ForwardIcon);
KuFoxIcons.displayName = 'FullscreenCancelOutlined';

export default KuFoxIcons;
